const STORAGE_KEY = 'patient_protocol_questions_v1';
export const PROTOCOL_QUESTIONS_UPDATED_EVENT = 'patient-protocol-questions-updated';

export interface PatientProtocolQuestion {
  id: string;
  protocolId: string;
  protocolTitle: string;
  patientId: string;
  patientName: string;
  question: string;
  askedAt: string;
  status: 'PENDING' | 'ANSWERED';
  answer?: string;
  answeredAt?: string;
}

const genId = () => `ppq-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const loadProtocolQuestions = (): PatientProtocolQuestion[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as PatientProtocolQuestion[];
  } catch {
    return [];
  }
};

export const saveProtocolQuestion = (
  q: Omit<PatientProtocolQuestion, 'id' | 'askedAt' | 'status'>
): void => {
  const existing = loadProtocolQuestions();
  const next: PatientProtocolQuestion = {
    ...q,
    id: genId(),
    askedAt: new Date().toISOString(),
    status: 'PENDING',
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify([next, ...existing]));
  window.dispatchEvent(new Event(PROTOCOL_QUESTIONS_UPDATED_EVENT));
};
